// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z8Kng","tabsBox":"styles_tabsBox__mWx9H","createButton":"styles_createButton__3PYk9"};